import { App } from 'vue'
import { registerI18nPlugin } from '@/services/i18n'

export default function registerPlugins(app: App) {
  registerI18nPlugin(app)
}
